import { Component } from '@angular/core';
import { take } from 'rxjs/operators';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ausmit';
  constructor(private themeService: ThemeService) {
    this.activateTheme();
  }
  activateTheme() {
    this.themeService.activateTheme('light-blue').pipe(take(1)).subscribe();
  }
}
